import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useBackofficeSearchCondition } from '@/providers/BackofficeSearchConditionProvider';
import { useInvoiceTaskPhases } from '@/hooks/api/1790_invoice_task_phases';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { useBusinessPartners } from '@/hooks/api/0430_business_partners';
import { useProducts } from '@/hooks/api/0390_products';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { invoiceTaskSearchCondition: searchCondition } = useBackofficeSearchCondition();
  const { data: phases } = useInvoiceTaskPhases();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: businessPartners } = useBusinessPartners({ identifier: _w_!.identifier, page: 1, per: 1000 });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });
  const { data: products } = useProducts({ identifier: _w_!.identifier });
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {searchCondition.subscribed && <span className="badge rounded-pill badge-info mx-1 my-1">マイリスト</span>}
      {searchCondition.billing_year_months.map((d) => (
        <span key={`ym-tag-${d}`} className="badge rounded-pill badge-info mx-1 my-1">
          {d}
        </span>
      ))}
      {phases &&
        phases
          .filter((d) => searchCondition.invoice_task_phase_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.business_partner_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.agency_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
      {teams &&
        teams.sales_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {products &&
        products
          .filter((d) => searchCondition.product_ids.includes(d.id))
          .map((d) => (
            <span key={`product-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {searchCondition.archived ? (
        <span className="badge rounded-pill badge-primary mx-1 my-1">アーカイブ済タスクを含める</span>
      ) : (
        <span className="badge rounded-pill badge-secondary mx-1 my-1">アーカイブ済タスクを含めない</span>
      )}
    </div>
  );
};
